import { useAppSelector } from 'src/store';
import { IUserInfo } from 'src/store/reducers/user';
import { Address, erc20Abi } from 'viem';
import { UseReadContractParameters, useAccount, useReadContract } from 'wagmi';

export interface UserErc20AllowanceVariables {
  tokenAddress: Address;
  contractAddress: Address;
  chainId?: number;
}

export const erc20AllowanceQueryOptions = (
  {
    tokenAddress,
    userAddress,
    contractAddress: vaultAddress,
    chainId,
  }: UserErc20AllowanceVariables & { userAddress: Address; chainId?: number },
  { query, ...options }: UseReadContractParameters<typeof erc20Abi, 'allowance'> = {},
) => {
  return {
    abi: erc20Abi,
    address: tokenAddress,
    functionName: 'allowance',
    args: [userAddress!, vaultAddress],
    chainId,
    query: {
      enabled: !!userAddress,
      ...query,
    },
    ...options,
  } as const;
};

export const useErc20Allowance = (
  { tokenAddress, contractAddress, chainId }: UserErc20AllowanceVariables,
  options?: UseReadContractParameters<typeof erc20Abi, 'allowance'>,
) => {
  const { address: userAddress } = useAccount();
  const userInfo: IUserInfo = useAppSelector((state) => state.user);

  const walletAddress = userAddress ?? userInfo.walletAddress;
  return useReadContract(
    erc20AllowanceQueryOptions(
      {
        tokenAddress,
        userAddress: walletAddress! as `0x${string}`,
        contractAddress,
        chainId,
      },
      options,
    ) as any,
  );
};
